import { FUNERAL_SIDO, FUNERAL_SIGUNGU } from "goi_common";
import { GetServerSideProps } from "next";
import cares from "@/constants/care_detail.json";
import CareRegionContainer from "@/containers/CareContainer/CareRegionContainer";
import Head from "next/head";
import NotFoundPage from "pages/404";

function replaceSiGunToBlank(str: string) {
  if (str.includes("시")) return str.substring(0, str.lastIndexOf("시"));
  if (str.includes("군")) return str.substring(0, str.lastIndexOf("군"));

  return str;
}

const getCareDataByRegionCode = (sidoCode: number, sigunguCode?: number) => {
  const careArray = cares as Array<any>;

  if (sigunguCode) {
    const sigunguParlorList = careArray.filter(
      (care) => String(care.sigungu) === String(sigunguCode)
    );

    if (sigunguParlorList.length) {
      return { regionCares: sigunguParlorList, hasSigungu: true };
    }
  }

  const sidoParlorList = careArray.filter(
    (care) => String(care.sido) === String(sidoCode)
  );

  return { regionCares: sidoParlorList, hasSigungu: false };
};

function getByValue(map: Map<number, any>, searchValue: any) {
  for (const [key, value] of map.entries()) {
    if (value === searchValue) return key;
  }
}

export const getServerSideProps: GetServerSideProps = async ({ params }) => {
  const code = params?.code as string;

  let sidoNumber;
  let sigunguNumber;
  let sigunguKeyword;

  const [sido, sigungu] = code.split("-");

  if (code.includes("-")) {
    sidoNumber = getByValue(FUNERAL_SIDO, sido);
    sigunguNumber = getByValue(
      FUNERAL_SIGUNGU.get(sidoNumber as number) as any,
      sigungu
    );
    sigunguKeyword = replaceSiGunToBlank(sigungu);
  } else {
    sidoNumber = getByValue(FUNERAL_SIDO, code);
  }

  if (!sidoNumber) {
    return { props: { hasError: true } };
  }

  const { regionCares, hasSigungu } = getCareDataByRegionCode(
    sidoNumber as number,
    sigunguNumber as number
  );

  const regionText = `${sido}${sigunguKeyword ? ` ${sigunguKeyword}` : ""}`;

  const description = `${regionText} 지역의 요양원 요양병원을 안내해드리며, 요양시설을 찾으실 때 필요한 정보 또한 안내드립니다. ${regionText}에는 ${regionCares.length}개의 요양시설이 있습니다.`;

  const hasError = !sidoNumber || (code.includes("-") && !sigunguNumber);
  return {
    props: {
      regionCares,
      hasError,
      hasSigungu,
      sidoName: sido,
      sido: sidoNumber,
      sigunguName: sigungu || "",
      sigungu: sigunguNumber || 0,
      pageOgTitle: `${regionText} 요양원 요양병원 추천, 안내, 소개 - [장례의 모든 것, 고이장례연구소]`,
      pageDescription: description,
      pageOgDescription: description,
      pageKeywords: `${regionText} 요양원, ${regionText} 요양병원, ${regionText} 요양시설, 요양원, 요양병원, 노인요양시설, 요양시설, 장기요양기관`,
      pageOgImage: "",
    },
  };
};

interface ParlorRegionPageProps {
  regionCares: Array<any>;
  hasError: boolean;
  hasSigungu: boolean;
  sido: string;
  sidoName: string;
  sigungu?: string;
  sigunguName?: string;
  isSigungu: boolean;
  pageOgTitle: string;
}

function ParlorRegionPage(props: ParlorRegionPageProps) {
  const { hasError, sidoName, sigunguName } = props;
  if (hasError) return <NotFoundPage />;

  return (
    <>
      <Head>
        <title>{props.pageOgTitle}</title>

        <link
          rel="canonical"
          href={`https://www.goifuneral.co.kr/care/region/${sidoName}${
            sigunguName ? `-${sigunguName}` : ""
          }/`}
          key="canonical"
        />
      </Head>
      <CareRegionContainer {...props} />
    </>
  );
}

export default ParlorRegionPage;
